<mat-card fxLayout="row" fxLayoutAlign="space-around center" style="height: 100%; width: 100%; box-shadow: none">
    <ngx-charts-bar-horizontal [animations]="false" [customColors]="customColors" [scheme]="scheme" [results]="data" title="''" [view]="view" [yAxis]="yAxis" [xAxis]="xAxis" [barPadding]="barPadding" [animations]="false">
    </ngx-charts-bar-horizontal>
</mat-card>